import Table from "../../Component/Common/Table";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getOrgUsers,
  deleteOrgUser,
  toggleOrgUserStatus,
  getOrgRoles,
} from "../../store/organizationUser/organizationUser.action";
import CreateOrgMembers from "../../Component/dialogue/CreateOrgMembers";
import Button from "../../Component/Common/Button";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import { handleEdit, handleOpenNew } from "../../util/Dialogue";
import { warning } from "../../util/Alert";
import BulkAddMembers from "./BulkAddMembers";

import UserImage from "../../assets/images/no-profile.jpg";
import PageContainer from "../../Component/Common/Page";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import Pagination from "../../Component/Common/Pagination";
import DataActions from "../../Component/Common/DataActions";
import MultiButton from "../../Component/extra/MultiButton";

const roles = {
  caregiver: "Caregiver",
  org_viewer: "Viewer",
  org_creator: "Creator",
  org_admin: "Admin",
  org_owner: "Owner",
};

const TabsName = {
  Tab1: "Members",
  Tab2: "Caregivers",
};

const OrgMembers = () => {
  const dispatch = useDispatch();
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { users, totalUsers } = useSelector((state) => state.organizationUser);
  const { profile } = useSelector((state) => state.loggedUser);

  const [currentTab, setCurrentTab] = useState(TabsName.Tab1);
  const [fetchCaregivers, setFetchCaregivers] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const handleDeleteUser = (userId) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = userId;
            dispatch(deleteOrgUser(id));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handleToggleStatus = (userId) => {
    dispatch(toggleOrgUserStatus(userId));
  };

  const empMapData = [
    {
      Header: "Image",
      Cell: ({ row }) => (
        <img
          src={row?.image || UserImage}
          alt={row.name}
          style={{
            height: 35,
            aspectRatio: 1,
            objectFit: "cover",
            borderRadius: 10,
          }}
          onError={(e) => {
            e.target.src = UserImage;
          }}
        />
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => <p className="fw-bold mb-0">{row?.name || "-"}</p>,
    },
    {
      Header: "Email",
      Cell: ({ row }) => <p className="mb-0">{row?.email || "-"}</p>,
    },
    {
      Header: "Phone",
      Cell: ({ row }) => (
        <p className="text-nowrap mb-0">{row?.phone || "-"}</p>
      ),
    },
    {
      Header: "Department",
      Cell: ({ row }) => (
        <p className="mb-0">{row?.departmentId?.name || "-"}</p>
      ),
    },
    {
      Header: "Role",
      Cell: ({ row }) => <p className="mb-0">{roles[row?.role] || "Viewer"}</p>,
    },
    {
      Header: "Courses Completed",
      Cell: ({ row }) => <p className="mb-0">{row?.coursesCompleted || 0}</p>,
    },
    ...(!fetchCaregivers
      ? [
          {
            Header: "Webapp Access",
            Cell: ({ row }) => (
              <p className="mb-0">
                {row.invitationStatus === "joined" ? "Joined" : "Invited"}
              </p>
            ),
          },
        ]
      : []),
    {
      Header: "Active",
      Cell: ({ row }) =>
        row._id !== profile?._id && row.role !== "org_owner" ? (
          <ToggleSwitch
            checked={row?.isActive}
            onChange={() => handleToggleStatus(row._id)}
          />
        ) : null,
    },
    {
      Header: "Actions",
      Cell: ({ row }) =>
        row._id !== profile?._id && row.role !== "org_owner" ? (
          <div className="d-flex justify-content-center gap-2">
            <Button
              className="icon-btn"
              startIcon={<EditIcon />}
              onClick={() => handleEdit(dispatch, "addOrgMembers", row)}
            />
            {profile?.role == "org_owner" && (
              <Button
                className="icon-btn"
                startIcon={<TrashIcon />}
                onClick={() => handleDeleteUser(row._id)}
              />
            )}
          </div>
        ) : null,
    },
  ];

  useEffect(() => {
    dispatch(getOrgRoles());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getOrgUsers({
        page,
        limit: size,
        searchText: debounceSearchText,
        fetchCaregivers,
      }),
    );
  }, [dispatch, page, size, debounceSearchText, fetchCaregivers]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  useEffect(() => {
    setPage(1);
    if (currentTab === TabsName.Tab2) {
      setFetchCaregivers(true);
    } else {
      setFetchCaregivers(false);
    }
  }, [currentTab]);

  return (
    <PageContainer>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Organization Members</h3>
        <div className="new-fake-btn d-flex gap-4 pe-lg-4">
          {/* {orgProfile?.subscriptionId?.status === "active" ? ( */}
          <Button
            className={"rounded"}
            onClick={() => handleOpenNew(dispatch, "bulkAddMembers")}
          >
            Bulk Add
          </Button>
          {/* ) : null} */}

          {/* {orgProfile?.subscriptionId?.status === "active" ? ( */}
          <Button
            className={"rounded"}
            startIcon={<AddIcon />}
            onClick={() => handleOpenNew(dispatch, "addOrgMembers")}
          >
            Add
          </Button>
          {/* ) : null} */}
        </div>
      </div>

      <MultiButton
        label={Object.values(TabsName)}
        multiButtonSelect={currentTab}
        setMultiButtonSelect={setCurrentTab}
      />

      <div className="user-table">
        <div className="user-table-top">
          <DataActions
            searchInputProps={{
              placeholder: "Search Name, Email",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
          />
        </div>

        <Table
          data={users}
          mapData={empMapData}
          noDataMessage={"No Member Found!"}
        />

        <div className="mt-3">
          <Pagination
            totalItem={totalUsers}
            activePage={page}
            pageSize={size}
            onActivePageChange={handlePageChange}
            onPageSizeChange={handleRowsPerPage}
          />
        </div>
      </div>

      {dialogueType === "addOrgMembers" && (
        <CreateOrgMembers currentTab={currentTab} />
      )}
      {dialogueType === "bulkAddMembers" && (
        <BulkAddMembers currentTab={currentTab} />
      )}
    </PageContainer>
  );
};

export default OrgMembers;
